import { SVGS } from 'app/constants/SVGS';
import { SideNavItem } from '../rankings/models/sideNavItem';

export const SIDENAV_ITEMS_RISK_CATEGORIES: Array<SideNavItem> = [
  {
    reportId: 'ipv4Addresses',
    title: 'IPv4 Addresses',
    id: 'ipv4-addresses',
    mapId: '',
    active: false,
    icon: SVGS.ipv4
  },
  {
    reportId: 'ipv6Addresses',
    title: 'IPv6 Addresses',
    id: 'ipv6-addresses',
    mapId: '',
    active: false,
    icon: SVGS.ipv6
  },
  {
    reportId: 'ctvDeviceIds',
    title: 'CTV Device IDs',
    id: 'ctv-device-ids',
    mapId: '',
    active: false,
    icon: SVGS.ctvDevice
  },
  {
    reportId: 'mobileDeviceIds',
    title: 'Mobile Device IDs',
    id: 'mobile-device-ids',
    mapId: '',
    active: false,
    icon: SVGS.mobileDevice
  },
  {
    reportId: 'dataCenterIps',
    title: 'Data Center IPs',
    id: 'data-center-ips',
    mapId: '',
    active: false,
    icon: SVGS.dataCenter
  },
  {
    reportId: 'malformedCtvBundles',
    title: 'Fraudulent CTV Bundle IDs',
    id: 'fraudulent-ctv-bundles',
    mapId: '',
    active: false,
    icon: SVGS.malformedCtv
  },
  {
    reportId: 'mobileDelistedApps',
    title: 'Mobile Delisted Apps',
    id: 'mobile-delisted-apps',
    mapId: '',
    active: false,
    icon: SVGS.mobileDelistedApps
  },
  {
    reportId: 'ctvDelistedApps',
    title: 'CTV Delisted Apps',
    id: 'ctv-delisted-apps',
    mapId: '',
    active: false,
    icon: SVGS.ctvDelistedApps
  },
  {
    reportId: 'mfaCtvApps',
    title: 'MFA CTV Apps',
    id: 'mfa-ctv-apps',
    mapId: '',
    active: false,
    icon: SVGS.mfaCtvApps,
    hidden: false
  },
  {
    reportId: 'mfaMobileApps',
    title: 'MFA Mobile Apps',
    id: 'mfa-mobile-apps',
    mapId: '',
    active: false,
    icon: SVGS.mfaMobileApps,
    hidden: false
  },
  {
    reportId: 'mfaDomains',
    title: 'MFA Domains',
    id: 'mfa-domains',
    mapId: '',
    active: false,
    icon: SVGS.mfaDomains,
    hidden: false
  }
];
